// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-sowos-pocket-tsx": () => import("./../../../src/pages/SowosPocket.tsx" /* webpackChunkName: "component---src-pages-sowos-pocket-tsx" */),
  "component---src-pages-sowos-wealth-tsx": () => import("./../../../src/pages/SowosWealth.tsx" /* webpackChunkName: "component---src-pages-sowos-wealth-tsx" */)
}

